import React, { useState, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../../components/atoms/Button';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../../components/foundations/Icon';
import css from './ActionBar.css';

const ActionBar = forwardRef(({ onRunRca = () => {}, onDismiss = () => {} }, ref) => {
    const [pointData, setPointData] = useState(null);

    useImperativeHandle(ref, () => ({
        show: data => setPointData(data),
        hide: () => setPointData(null),
    }));

    if (!pointData) return null;

    const parts = pointData.custom?.dimValues ?? [];

    return (
        <div className={css.actionBar}>
            <div className={css.actionBarContent}>
                <div className={css.breadcrumb}>
                    {parts.map((part, i) => (
                        <React.Fragment key={part}>
                            {i > 0 && <Icon name="arrow-right" size={IconSizes.X_SMALL} />}
                            <span className={classNames({ [css.breadcrumbActive]: i === parts.length - 1 })}>{part}</span>
                        </React.Fragment>
                    ))}
                </div>
                <div className={css.actionBarActions}>
                    <Button
                        type="primary"
                        text="STATIC.PAGES.ANOMALY_ANALYSIS.INVESTIGATE_WITH_AI"
                        Icon="sparkles"
                        iconVariant={IconVariants.WHITE}
                        iconSize={IconSizes.X_SMALL}
                        className={css.rcaButton}
                        onClick={() => {
                            onRunRca(pointData);
                            setPointData(null);
                        }}
                    />
                    <Icon
                        type={IconTypes.MINGCUTE}
                        name="close-line"
                        variant={IconVariants.DARK}
                        size={IconSizes.SMALL}
                        interactive
                        onClick={() => {
                            onDismiss();
                            setPointData(null);
                        }}
                    />
                </div>
            </div>
        </div>
    );
});

ActionBar.displayName = 'ActionBar';

ActionBar.propTypes = {
    onRunRca: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};

export default ActionBar;
